<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZWh18E/tc-custom/9781398481879.jpg?1741432588461" alt="This image is the cover for the book Diamond in the Unknown"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Diamond in the Unknown
      </h1>
      <p class="bookDescription body article font2">
        <p>Diamond had nothing except a lamenting heart when she embarked on a journey into the unknown, for she had a little hope. As the journey continues, she loses the last piece of hope she had; but the journey continues, with no option of turning back. There is still a way to go, and her heart is filled with all sorts of fears; fear of the unknown; fear of loss of love; fear of death, but not of her own. But how would she escape when giving up is not an option? How would she face her fears when fear does not have a face? And how would she relieve her pain when the battle is continuous, and there is no time to breathe? It only becomes possible if the fire within you is stronger than the fire outside. But that is not the only battle; the other struggle is to save the love; the last hope to continue with life. But how? When love is in question, then love is the answer.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        S.K. Benz
      </h2>
      
      <p class="authorDescription body article">S.K. Benz believes story is not written with a pen; it comes from the heart, guided by the soul. Every word symbolises aliveness, drawn on the paper that gives virtue of love to whoever reads it. We call it creativity. Benz constantly desired to tell stories, but something was always a miss; then one day magic happened. She fell in love with life which was the missing piece of the puzzle for loving life is the most serene experience. She hopes that every word you read fills your life with love and joy!!!</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?af80596c